import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';

export class VisionScenario extends BasicScenario {
manageKeys: boolean | null;
manageMeasures: boolean | null;
manageSteps: boolean | null;
}

